module.exports = __webpack_public_path__ + "assets/play.png?0d1d6fd0cb8ec682d27c61d5a6974a5a";